// Country/destination stock photos for trip cover images
const COUNTRY_PHOTOS = {
  "France": "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&q=80",
  "Italy": "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=600&q=80",
  "Japan": "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=600&q=80",
  "Spain": "https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=600&q=80",
  "United States": "https://images.unsplash.com/photo-1485738422979-f5c462d49f04?w=600&q=80",
  "Thailand": "https://images.unsplash.com/photo-1528181304800-259b08848526?w=600&q=80",
  "Greece": "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=600&q=80",
  "Portugal": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=600&q=80",
  "Germany": "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=600&q=80",
  "United Kingdom": "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&q=80",
  "Turkey": "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=600&q=80",
  "Netherlands": "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=600&q=80",
  "Indonesia": "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=600&q=80",
  "Switzerland": "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?w=600&q=80",
  "Australia": "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=600&q=80",
  "Mexico": "https://images.unsplash.com/photo-1518638150340-f706e86654de?w=600&q=80",
  "Brazil": "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=600&q=80",
  "India": "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=600&q=80",
  "Morocco": "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?w=600&q=80",
  "Egypt": "https://images.unsplash.com/photo-1539768942893-daf53e736b68?w=600&q=80",
  "Norway": "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=600&q=80",
  "Iceland": "https://images.unsplash.com/photo-1529963183134-61a90db47eaf?w=600&q=80",
  "South Korea": "https://images.unsplash.com/photo-1538485399081-7191377e8241?w=600&q=80",
  "Croatia": "https://images.unsplash.com/photo-1555990793-da11153b2473?w=600&q=80",
  "Austria": "https://images.unsplash.com/photo-1516550893923-42d28e5677af?w=600&q=80",
  "Peru": "https://images.unsplash.com/photo-1526392060635-9d6019884377?w=600&q=80",
  "Vietnam": "https://images.unsplash.com/photo-1528127269322-539801943592?w=600&q=80",
  "New Zealand": "https://images.unsplash.com/photo-1469521669194-babb45599def?w=600&q=80",
  "Czech Republic": "https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=600&q=80",
  "South Africa": "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=600&q=80",
  "Singapore": "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=600&q=80",
  "Ireland": "https://images.unsplash.com/photo-1590089415225-401ed6f9db8e?w=600&q=80",
  "Canada": "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=600&q=80",
  "Sweden": "https://images.unsplash.com/photo-1509356843151-3e7d96241e11?w=600&q=80",
  "Denmark": "https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=600&q=80",
  "Poland": "https://images.unsplash.com/photo-1519197924294-4ba991a11128?w=600&q=80",
  "Colombia": "https://images.unsplash.com/photo-1536184293005-3c2dbb5a76c5?w=600&q=80",
  "Argentina": "https://images.unsplash.com/photo-1612294037637-ec328d0e075e?w=600&q=80",
  "Cuba": "https://images.unsplash.com/photo-1500759285222-a95626b934cb?w=600&q=80",
  "China": "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=600&q=80",
  "Finland": "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=600&q=80",
  "Belgium": "https://images.unsplash.com/photo-1559113202-c916b8e44373?w=600&q=80",
  "Hungary": "https://images.unsplash.com/photo-1551867633-194f125bddfa?w=600&q=80",
  "Romania": "https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?w=600&q=80",
  "Tanzania": "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=600&q=80",
  "Kenya": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=600&q=80",
  "Philippines": "https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?w=600&q=80",
  "Malaysia": "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=600&q=80",
  "UAE": "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&q=80",
  "United Arab Emirates": "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&q=80",
  "Jordan": "https://images.unsplash.com/photo-1580834341580-8c17a3a630ca?w=600&q=80",
  "Scotland": "https://images.unsplash.com/photo-1506377585622-bedcbb027afc?w=600&q=80",
};

const FALLBACK_PHOTOS = [
  "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=600&q=80",
  "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&q=80",
  "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=600&q=80",
  "https://images.unsplash.com/photo-1530789253388-582c481c54b0?w=600&q=80",
  "https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=600&q=80",
];

export const getTripCoverPhoto = (country) => {
  if (!country) return FALLBACK_PHOTOS[0];
  
  // Exact match
  if (COUNTRY_PHOTOS[country]) return COUNTRY_PHOTOS[country];
  
  // Partial match
  const key = Object.keys(COUNTRY_PHOTOS).find(
    (k) => k.toLowerCase().includes(country.toLowerCase()) || country.toLowerCase().includes(k.toLowerCase())
  );
  if (key) return COUNTRY_PHOTOS[key];
  
  // Deterministic fallback based on country name
  const hash = country.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return FALLBACK_PHOTOS[hash % FALLBACK_PHOTOS.length];
};

// Country-specific photos by ISO 2-letter code for Country & Visa page
const COUNTRY_CODE_PHOTOS = {
  "AF": "https://images.unsplash.com/photo-1673701348866-eaa57db8aba6?w=400&q=80",
  "AL": "https://images.unsplash.com/photo-1653982969676-2408ca464041?w=400&q=80",
  "DZ": "https://images.unsplash.com/photo-1583508805133-8fd03a9916d4?w=400&q=80",
  "AD": "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?w=400&q=80",
  "AO": "https://images.unsplash.com/photo-1738701243287-df5b46011c2f?w=400&q=80",
  "AG": "https://images.unsplash.com/photo-1560779751-6f55494519a8?w=400&q=80",
  "AR": "https://images.unsplash.com/photo-1612294037637-ec328d0e075e?w=400&q=80",
  "AM": "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&q=80",
  "AU": "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=400&q=80",
  "AT": "https://images.unsplash.com/photo-1516550893923-42d28e5677af?w=400&q=80",
  "AZ": "https://images.unsplash.com/photo-1744790417678-eb901145af73?w=400&q=80",
  "BS": "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=400&q=80",
  "BH": "https://images.unsplash.com/photo-1562095241-8c6714fd4178?w=400&q=80",
  "BD": "https://images.unsplash.com/photo-1583508805133-8fd03a9916d4?w=400&q=80",
  "BB": "https://images.unsplash.com/photo-1630116521535-c57e5487cb42?w=400&q=80",
  "BY": "https://images.unsplash.com/photo-1513326738677-b964603b136d?w=400&q=80",
  "BE": "https://images.unsplash.com/photo-1559113202-c916b8e44373?w=400&q=80",
  "BZ": "https://images.unsplash.com/photo-1683480844295-26f32c6b3fe9?w=400&q=80",
  "BJ": "https://images.unsplash.com/photo-1759212320679-f30f35a03f43?w=400&q=80",
  "BT": "https://images.unsplash.com/photo-1553856622-d1b352e9a211?w=400&q=80",
  "BO": "https://images.unsplash.com/photo-1591378603223-e15b45a81640?w=400&q=80",
  "BA": "https://images.unsplash.com/photo-1643054136954-684629fedc90?w=400&q=80",
  "BW": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "BR": "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=400&q=80",
  "BN": "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=400&q=80",
  "BG": "https://images.unsplash.com/photo-1722447145262-3ff87e068c95?w=400&q=80",
  "BF": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "BI": "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=400&q=80",
  "CV": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "KH": "https://images.unsplash.com/photo-1768882902762-b0c17224c875?w=400&q=80",
  "CM": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "CA": "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=400&q=80",
  "CF": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "TD": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "CL": "https://images.unsplash.com/photo-1469521669194-babb45599def?w=400&q=80",
  "CN": "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=400&q=80",
  "CO": "https://images.unsplash.com/photo-1678422151003-4a920e7a3de8?w=400&q=80",
  "KM": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "CG": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "CR": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "HR": "https://images.unsplash.com/photo-1555990793-da11153b2473?w=400&q=80",
  "CU": "https://images.unsplash.com/photo-1500759285222-a95626b934cb?w=400&q=80",
  "CY": "https://images.unsplash.com/flagged/photo-1557006027-cf0673ec2cfa?w=400&q=80",
  "CZ": "https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=400&q=80",
  "DK": "https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=400&q=80",
  "DJ": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "DM": "https://images.unsplash.com/photo-1560779751-6f55494519a8?w=400&q=80",
  "DO": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "EC": "https://images.unsplash.com/photo-1566438480900-0609be27a4be?w=400&q=80",
  "EG": "https://images.unsplash.com/photo-1654404886332-9614c4fde3f7?w=400&q=80",
  "SV": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "GQ": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "ER": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "EE": "https://images.unsplash.com/photo-1560969184-10fe8719e047?w=400&q=80",
  "SZ": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "ET": "https://images.unsplash.com/photo-1523805009345-7448845a9e53?w=400&q=80",
  "FJ": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "FI": "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=400&q=80",
  "FR": "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=400&q=80",
  "GA": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "GM": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "GE": "https://images.unsplash.com/photo-1565008576549-57569a49371d?w=400&q=80",
  "DE": "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=400&q=80",
  "GH": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "GR": "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=400&q=80",
  "GD": "https://images.unsplash.com/photo-1683480844295-26f32c6b3fe9?w=400&q=80",
  "GT": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "GN": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "GW": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "GY": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "HT": "https://images.unsplash.com/photo-1630116521535-c57e5487cb42?w=400&q=80",
  "HN": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "HU": "https://images.unsplash.com/photo-1551867633-194f125bddfa?w=400&q=80",
  "IS": "https://images.unsplash.com/photo-1529963183134-61a90db47eaf?w=400&q=80",
  "IN": "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=400&q=80",
  "ID": "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=400&q=80",
  "IR": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "IQ": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "IE": "https://images.unsplash.com/photo-1590089415225-401ed6f9db8e?w=400&q=80",
  "IL": "https://images.unsplash.com/photo-1547483238-2cbf881a559f?w=400&q=80",
  "IT": "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=400&q=80",
  "JM": "https://images.unsplash.com/photo-1612292063926-891ab31ebc85?w=400&q=80",
  "JP": "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=400&q=80",
  "JO": "https://images.unsplash.com/photo-1580834341580-8c17a3a630ca?w=400&q=80",
  "KZ": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "KE": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "KI": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "KP": "https://images.unsplash.com/photo-1538485399081-7191377e8241?w=400&q=80",
  "KR": "https://images.unsplash.com/photo-1538485399081-7191377e8241?w=400&q=80",
  "KW": "https://images.unsplash.com/photo-1562095241-8c6714fd4178?w=400&q=80",
  "KG": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "LA": "https://images.unsplash.com/photo-1528181304800-259b08848526?w=400&q=80",
  "LV": "https://images.unsplash.com/photo-1560969184-10fe8719e047?w=400&q=80",
  "LB": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "LS": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "LR": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "LY": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "LI": "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?w=400&q=80",
  "LT": "https://images.unsplash.com/photo-1560969184-10fe8719e047?w=400&q=80",
  "LU": "https://images.unsplash.com/photo-1559113202-c916b8e44373?w=400&q=80",
  "MG": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "MW": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "MY": "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=400&q=80",
  "MV": "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=400&q=80",
  "ML": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "MT": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "MH": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "MR": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "MU": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "MX": "https://images.unsplash.com/photo-1518638150340-f706e86654de?w=400&q=80",
  "FM": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "MD": "https://images.unsplash.com/photo-1560969184-10fe8719e047?w=400&q=80",
  "MC": "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=400&q=80",
  "MN": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "ME": "https://images.unsplash.com/photo-1555990793-da11153b2473?w=400&q=80",
  "MA": "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?w=400&q=80",
  "MZ": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "MM": "https://images.unsplash.com/photo-1528181304800-259b08848526?w=400&q=80",
  "NA": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "NR": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "NP": "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=400&q=80",
  "NL": "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=400&q=80",
  "NZ": "https://images.unsplash.com/photo-1469521669194-babb45599def?w=400&q=80",
  "NI": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "NE": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "NG": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "MK": "https://images.unsplash.com/photo-1555990793-da11153b2473?w=400&q=80",
  "NO": "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=400&q=80",
  "OM": "https://images.unsplash.com/photo-1722929207107-013cfb21068f?w=400&q=80",
  "PK": "https://images.unsplash.com/photo-1566837945700-30057527ade0?w=400&q=80",
  "PW": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "PS": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "PA": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "PG": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "PY": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "PE": "https://images.unsplash.com/photo-1526392060635-9d6019884377?w=400&q=80",
  "PH": "https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?w=400&q=80",
  "PL": "https://images.unsplash.com/photo-1519197924294-4ba991a11128?w=400&q=80",
  "PT": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=400&q=80",
  "QA": "https://images.unsplash.com/photo-1562095241-8c6714fd4178?w=400&q=80",
  "RO": "https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?w=400&q=80",
  "RU": "https://images.unsplash.com/photo-1513326738677-b964603b136d?w=400&q=80",
  "RW": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "KN": "https://images.unsplash.com/photo-1560779751-6f55494519a8?w=400&q=80",
  "LC": "https://images.unsplash.com/photo-1630116521535-c57e5487cb42?w=400&q=80",
  "VC": "https://images.unsplash.com/photo-1683480844295-26f32c6b3fe9?w=400&q=80",
  "WS": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "SM": "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=400&q=80",
  "ST": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "SA": "https://images.unsplash.com/photo-1562095241-8c6714fd4178?w=400&q=80",
  "SN": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "RS": "https://images.unsplash.com/photo-1555990793-da11153b2473?w=400&q=80",
  "SC": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "SL": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "SG": "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=400&q=80",
  "SK": "https://images.unsplash.com/photo-1560969184-10fe8719e047?w=400&q=80",
  "SI": "https://images.unsplash.com/photo-1555990793-da11153b2473?w=400&q=80",
  "SB": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "SO": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "ZA": "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=400&q=80",
  "SS": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "ES": "https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=400&q=80",
  "LK": "https://images.unsplash.com/photo-1586348943529-beaae6c28db9?w=400&q=80",
  "SD": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "SR": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "SE": "https://images.unsplash.com/photo-1509356843151-3e7d96241e11?w=400&q=80",
  "CH": "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?w=400&q=80",
  "SY": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "TW": "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=400&q=80",
  "TJ": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "TZ": "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=400&q=80",
  "TH": "https://images.unsplash.com/photo-1528181304800-259b08848526?w=400&q=80",
  "TL": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "TG": "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=400&q=80",
  "TO": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "TT": "https://images.unsplash.com/photo-1560779751-6f55494519a8?w=400&q=80",
  "TN": "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?w=400&q=80",
  "TR": "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=400&q=80",
  "TM": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "TV": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "UG": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "UA": "https://images.unsplash.com/photo-1770112095032-693a32cace1d?w=400&q=80",
  "AE": "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=400&q=80",
  "GB": "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=400&q=80",
  "US": "https://images.unsplash.com/photo-1695189993006-975fb45964de?w=400&q=80",
  "UY": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "UZ": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "VU": "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&q=80",
  "VA": "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=400&q=80",
  "VE": "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=400&q=80",
  "VN": "https://images.unsplash.com/photo-1528127269322-539801943592?w=400&q=80",
  "YE": "https://images.unsplash.com/photo-1565711561500-49678a10a63f?w=400&q=80",
  "ZM": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
  "ZW": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=400&q=80",
};

const GENERIC_FALLBACK = "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=400&q=80";

export const getCountryPhotoByCode = (code) => {
  return COUNTRY_CODE_PHOTOS[code] || GENERIC_FALLBACK;
};
